import { Component, ElementRef, Input } from '@angular/core';

@Component({
    selector: 'm4u-status-column',
    templateUrl: './status-column.component.html',
    styleUrls: ['./status-column.component.scss']
})
export class StatusColumnComponent {

    @Input() Icon: string;
    @Input() IconUrl: string;
    @Input() Text: string;
    @Input() Color: string;
    @Input() Position: 'start' | 'center' | 'end' = 'start';

    constructor(private elRef: ElementRef) { }

    GetClass() {
        return `status-column-position-${this.Position}`;
    }

    getHtmlContent() {
        return this.elRef.nativeElement;
    }
}
